import '@/styles/supervise.scss';
import React from 'react';
import { Toast, Tabs, Button } from 'antd-mobile';
import { LoadingAlert, MessageConfirm } from '@/pages/manage/common';
import { detail as conferencedetail, getReplayList } from '@/services/saas/conference';
import { detail as getAttributeDetail } from '@/services/saas/attribute';
import { getViewUrl } from '@/services/saas/res';
import { submit, update } from '@/services/saas/supervisionFile';
import {
  save,
  detail,
  detailForUser,
  allList,
  ifsettingsuser,
} from '@/services/saas/supervisionRecord';
import { list as getSupervisionPlan, getExpanInfo } from '@/services/saas/supervisionScheme';
import { getUser, checkPermition } from '@/utils';
import Screenshot from './component/screenshot';
import SupervisionScore from './component/supervisionScore';
import ClassroomDiscipline from './component/classroomDiscipline';
import ClassroomEvaluation from './component/classroomEvaluation';
import ClassroomRecord from './component/classroomRecord';
import PlayerView from '@/components/playerView';
import moment from 'moment';
import { ShotModal, MarkerModal } from './component/supervisionModal';
import { dataURLtoFile } from '@/utils/Func';
import FileUploader from './component/upload/fileUpload';
import ClassroomBehavior from './component/classroomBehavior';
import _ from 'lodash';

const TabsInfo = [
  { title: '督导评分' },
  { title: '课堂行为' },
  { title: '课堂纪律' },
  { title: '课堂评价' },
];

const ConferenceInfo = (props) => {
  const {
    conferenceInfo: {
      name,
      teacherName,
      actualStartTime,
      attributeValueName,
      memberName,
      supervisorName,
      supervisorScore,
    },
  } = props;
  return (
    <div className="supervise-detailInfo">
      <h3>
        <em></em>
        <span>{name}</span>
      </h3>
      <p>
        <label>
          老师：<span>{teacherName || '无'}</span>
        </label>
        <label>
          开始时间：
          <span>{actualStartTime ? moment(actualStartTime).format('YYYY-MM-DD HH:mm') : '无'}</span>
        </label>
      </p>
      <p>
        <label>
          学科：<span>{attributeValueName ? attributeValueName : '无'}</span>
        </label>
        <label>
          教室：<span>{memberName || '无'}</span>
        </label>
      </p>
      <p>
        {supervisorName && (
          <label>
            督导员：<span>{supervisorName || '无'}</span>
          </label>
        )}
        {supervisorScore && (
          <label>
            督导评分：<span>{supervisorScore || '无'}</span>
          </label>
        )}
      </p>
    </div>
  );
};

const FileList = (props) => {
  const { value, list, handleClick = () => {} } = props;
  const typesMap = new Map([
    ['1', '视频'],
    ['2', '文档'],
    ['3', '图片'],
    ['4', 'flash'],
    ['5', '音频'],
    ['6', 'material'],
  ]);
  return (
    <div className="supervise-file-list">
      <div className="supervise-file-title">播放列表</div>
      <div className="file-list-container">
        {list
          // .filter((item) => ['1', '2', '3', '5'].indexOf(item.type) > -1)
          .map((item, index) => (
            <div
              onClick={() => handleClick(item)}
              className={`file-list-item ${value === item.fileInfoId ? 'active' : ''}`}
              key={`type-${index}`}
            >
              <span>{`${typesMap.get(item.type)}: `}</span>
              <span>{item.name}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

class Supervise extends React.Component {
  constructor() {
    super();
    this.handleSubmit = _.debounce(this.handleSubmit, 300);
  }

  state = {
    isSuperviser: false,
    type: undefined,
    detail: undefined,
    detailList: [],
    shotModal: {
      visible: false,
      record: {},
    },
    markerModal: {
      visible: false,
      record: {},
    },
    media: {
      mode: 'live',
      type: undefined,
      fileInfoId: undefined,
    },
    resource: {
      list: [],
      selectKey: undefined,
    },
    conference: undefined,
    conferenceInfo: undefined,
    // 评分id
    planId: undefined,
    // 评分options
    planOptions: [],
    // 截图附件id
    discipline: [],
    // 打点
    markers: {},
    // 分数
    store: {},
    // 行为
    activity: {
      // 1=是 2=否
      ifAnormal: '2',
      // 其它异常现象
      otherAnormal: undefined,
      // 睡觉人数
      sleepNum: 0,
      // 缺勤人数
      absenceNum: 0,
      // 其他违纪行为
      otherBehavior: undefined,
      // 课堂评价
      evaluate: undefined,
      // 教学活动
      teacherActivitier: '',
      // 学生活动
      studentActivitier: '',
      // 异常现象 逗号分隔 汉字
      phenomenonId: '',
    },
    player: undefined,
    uploader: undefined,
    error: undefined,
  };

  componentDidMount() {
    this.getDefault();
  }

  getDefault = async () => {
    await this.goPermition();
    await this.getConference();
    await this.checkType();
    await this.checkSuperviser();
    const { type, isSuperviser } = this.state;
    if (isSuperviser) {
      if (type) {
        await this.handleDetail();
        await this.getExpanInfo();
      } else {
        await this.handleDetailList();
      }
      await this.getPlan();
    }
    await this.getPlay();
  };

  getExpanInfo = async () => {
    const { conference, detail } = this.state;
    if (conference && !detail) {
      const {
        memberId: classroomId,
        id: conferenceId,
        actualStartTime,
        actualEndTime,
        conferenceStatus,
      } = conference;
      const newPayload = {};
      const param = {};
      if (conferenceStatus === '2') {
        param.startTime = actualStartTime;
        param.endTime = actualEndTime;
      }
      const resp = await getExpanInfo({ classroomId, conferenceId, ...param });
      if (resp && resp.success) {
        const { sleepNum, absenceNum } = resp.data;
        if (sleepNum !== null && sleepNum !== undefined) {
          newPayload.sleepNum = sleepNum;
        }
        if (absenceNum !== null && absenceNum !== undefined) {
          newPayload.absenceNum = absenceNum;
        }
      }
      this.setState({
        activity: {
          ...this.state.activity,
          ...newPayload,
        },
      });
    }
  };

  checkSuperviser = async () => {
    const newPayload = {
      isSuperviser: false,
    };
    const { conference } = this.state;
    const { userId: teacherId } = getUser() || {};
    if (teacherId && conference) {
      const { actualStartTime: time } = conference;
      if (teacherId && time) {
        const resp = await ifsettingsuser({ time: time.split(' ')[0], teacherId });
        if (resp && resp.success) {
          newPayload.isSuperviser = resp.data === 'true';
        }
      }
    }
    this.setState(newPayload);
  };

  goPermition = () => {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    const bizType = 'conference';
    return new Promise((resolve, reject) => {
      checkPermition(id, bizType, null, () => {
        resolve(true);
      });
    });
  };

  checkType = async () => {
    const {
      match: {
        params: { type },
      },
    } = this.props;
    const payload = {};
    if (type !== 'detail') {
      if (type === 'live') {
        payload.type = '1';
      }
      if (type === 'back') {
        payload.type = '2';
      }
    }
    this.setState(payload);
  };

  getPlay = async () => {
    const { conference } = this.state;
    if (conference) {
      const { detail, type } = this.state;
      if (type === '2') {
        this.getPlayfiles();
      } else if (type === '1') {
        this.getPlaylive();
        if (!detail) {
          this.getUpload();
        }
      }
    }
  };

  getPlayfiles = async () => {
    let {
      conference: {
        id,
        liveRecordInfo: { mbsType },
      },
    } = this.state;
    const payload = {};
    const bizType = 'conference';
    if (id && mbsType && bizType) {
      const response = await getReplayList({ bizId: id, bizType });
      if (response.success) {
        const fileList = response.data.map((file) => ({
          type: file.fileType,
          fileInfoId: file.fileInfoId,
          name: file.fileName,
          detailId: file.detailId,
        }));
        if (fileList.length === 0) {
          payload.error = '无可回看资源';
        } else {
          const [obj] = fileList;
          payload.media = {
            mode: 'file',
            fileInfoId: obj.fileInfoId,
            type: obj.type,
          };
          payload.resource = {
            selectKey: obj.fileInfoId,
            list: fileList,
          };
        }
      } else {
        payload.error = response.msg;
      }
    }
    this.setState(payload);
  };

  getPlaylive = () => {
    let {
      conference: {
        liveRecordInfo: { fileinfoId },
        conferenceStatus,
      },
    } = this.state;
    const payload = {};
    if (String(conferenceStatus) === '0' || !fileinfoId) {
      payload.error = '直播未开始，请稍后再来~';
    } else if (String(conferenceStatus) === '2') {
      payload.error = '直播已结束';
    } else {
      payload.media = {
        mode: 'live',
        fileInfoId: fileinfoId,
        type: undefined,
      };
    }
    this.setState(payload);
  };

  getConference = async () => {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    const resp = await conferencedetail({ id });
    const payload = {};
    if (resp && resp.success) {
      payload.conference = resp.data;
      this.setState(payload);
      await this.getConferenceInfo(resp.data);
    } else {
      this.setState({ error: resp.msg });
    }
  };

  getConferenceInfo = async (conference) => {
    const {
      name,
      deptName,
      memberName,
      teachInfo: { lecturerName: teacherName },
      conferenceAttributeDetailList,
      conferenceStatus,
      actualStartTime,
    } = conference;
    const attribute = { attributeValueName: '' };
    // Object.keys(keys).forEach((key) => {
    //   const [obj] = conferenceAttributeDetailList.filter((item) => item.attributeId === keys[key]);
    //   attribute[key] = obj;
    // });
    for (const item of conferenceAttributeDetailList) {
      const resp = await getAttributeDetail({ attributeId: item.attributeId });
      if (resp && resp.success) {
        const data = resp.data;
        attribute[data.attributeCode] = item;
      }
      attribute.attributeValueName += item.attributeValueName + ' ';
    }
    const conferenceInfo = {
      name,
      deptName,
      memberName,
      teacherName,
      conferenceStatus,
      actualStartTime,
      ...attribute,
    };
    this.setState({ conferenceInfo });
  };

  handleFileClick = (item) => {
    const { resource } = this.state;
    const payload = {};
    payload.media = {
      mode: 'file',
      fileInfoId: item.fileInfoId,
      type: item.type,
    };
    payload.resource = {
      ...resource,
      selectKey: item.fileInfoId,
    };
    this.setState(payload);
  };

  handleSnapshot = (url) => {
    if (this.state.player) {
      const times = Date.now();
      const shotModal = {
        visible: true,
        record: {
          type: 1,
          url,
          times,
          describes: undefined,
        },
      };
      this.setState({ shotModal });
    }
  };

  handleMarker = (e) => {
    const { player, media } = this.state;
    if (player && (media.type === '1' || media.type === '5')) {
      const { player } = this.state;
      const timestr = player.getCurrentTime();
      const markerModal = {
        visible: true,
        record: {
          timestr,
          describes: undefined,
        },
      };
      player.pause && player.pause();
      this.setState({ markerModal });
    }
  };

  getUpload = () => {
    const {
      conference: {
        liveRecordInfo: { mbsType },
      },
    } = this.state;
    if (mbsType) {
      const { deptId } = getUser() || {};
      const uploader = new FileUploader({ platformType: mbsType, deptId });
      uploader.handleUploadProgress = (progress) => {};
      this.setState({ uploader });
    }
  };

  handleSyncAppendix = async (value) => {
    let { url, ...data } = value;
    if (!data.id) {
      LoadingAlert('上传中...');
      const file = dataURLtoFile(url, `${Date.now()}.png`, 'image/png');
      const fileInfos = await this.handleUpload(file, { fileType: '3' });
      if (!fileInfos) {
        return;
      }
      const { fileInfoId: fileinfoId } = fileInfos;
      data = {
        ...data,
        fileinfoId,
      };
      const respSubmit = await submit(data);
      if (!respSubmit || respSubmit.success !== true) {
        return;
      }
      data.id = respSubmit.data.id;
      Toast.info('上传成功');
    } else {
      const respUpdate = await update(data);
      if (!respUpdate || respUpdate.success !== true) {
        return;
      }
    }
    const { id } = value;
    let { discipline } = this.state;
    if (id != null) {
      const index = discipline.findIndex((item) => item.id === id);
      discipline[index] = data;
    } else {
      discipline = [...discipline, data];
    }
    this.setState({
      discipline,
      shotModal: { visible: false, record: { ...this.state.shotModal.record } },
    });
  };

  handleSyncMark = async (value) => {
    const { index, ...data } = value;
    let {
      player,
      markers,
      resource: { selectKey },
    } = this.state;
    if (!markers[selectKey]) {
      markers[selectKey] = [];
    }
    if (index != null) {
      markers[selectKey][index] = data;
    } else {
      markers[selectKey] = [...markers[selectKey], data];
    }
    markers[selectKey] = markers[selectKey].sort((a, b) => a.timestr - b.timestr);
    await this.setState({ markers, markerModal: { visible: false, record: undefined } });
    this.setPlayMarkers();
    player.play && player.play();
  };

  setPlayMarkers = () => {
    const {
      player,
      markers,
      resource: { selectKey },
    } = this.state;
    if (player) {
      let _markers = [{}];
      if (selectKey && markers[selectKey] && markers[selectKey].length > 0) {
        _markers = markers[selectKey].map((item) => ({
          text: item.describes,
          offset: item.timestr,
        }));
      }
      player.setProgressMarkers && player.setProgressMarkers(_markers);
    }
  };

  handleReShowShot = async (item) => {
    const { fileinfoId } = item;
    const url = await this.getViewUrl(fileinfoId);
    const shotModal = {
      visible: true,
      record: {
        ...item,
        url,
      },
    };
    this.setState({ shotModal });
  };

  handleRemoveShot = async (item, index) => {
    await MessageConfirm('确定要删除?');
    let { discipline } = this.state;
    if (index != null) {
      discipline.splice(index, 1);
    }
    this.setState({ discipline });
  };

  handleReShowMarkers = async (item, index) => {
    const markerModal = {
      visible: true,
      record: {
        index,
        ...item,
      },
    };
    this.setState({ markerModal });
  };

  getViewUrl = async (fileInfoId) => {
    const repPlayUrl = await getViewUrl({
      fileInfoId,
    });
    if (repPlayUrl && repPlayUrl.success) {
      return repPlayUrl.data;
    }
  };

  handleUpload = (file, options) => {
    const { uploader } = this.state;
    if (uploader) {
      return new Promise((resolve, reject) => {
        uploader.handleUploadComplete = (fileInfo) => {
          resolve(fileInfo);
        };
        uploader.handleUploadError = () => {
          reject();
        };
        uploader.uploadFile(file, options);
      });
    }
  };

  handleDetailList = async () => {
    const {
      match: {
        params: { id: curriculumId },
      },
    } = this.props;
    const resp = await allList({ curriculumId });
    let _payload = {};
    if (resp && resp.success) {
      const data = resp.data;
      if (data) {
        _payload.detailList = data;
        if (data.length > 0) {
          const [{ id }] = data;
          const resp = await detail({ id });
          if (resp && resp.success) {
            const result = resp.data;
            await this.detailFormatter(result);
            _payload.type = result.type;
          }
        }
      }
      await this.setState(_payload);
    }
  };

  handleDetail = async () => {
    const {
      match: {
        params: { id: curriculumId },
      },
    } = this.props;
    const resp = await detailForUser({ curriculumId });
    if (resp && resp.success) {
      const data = resp.data;
      if (data && JSON.stringify(data) !== '{}') {
        await this.detailFormatter(data);
      }
    }
  };

  detailFormatter = async (payload) => {
    let _payload = {};
    const data = payload;
    const store = {};
    // const type = data.type;
    data.supervisionscorelist.forEach((item) => {
      store[item.indexId] = item.score;
    });

    const activity = {
      ifAnormal: data.ifAnormal,
      otherAnormal: data.otherAnormal,
      sleepNum: data.sleepNum,
      absenceNum: data.absenceNum,
      otherBehavior: data.otherBehavior,
      evaluate: data.evaluate,
      teacherActivitier: data.teacherActivitier,
      studentActivitier: data.studentActivitier,
      phenomenonId: data.phenomenonId,
    };

    const markers = {};
    data.afterlist
      .sort((a, b) => a.timestr - b.timestr)
      .forEach((item) => {
        const { fileinfoId } = item;
        if (!markers[fileinfoId]) {
          markers[fileinfoId] = [];
        }
        markers[fileinfoId].push({
          fileinfoId,
          timestr: item.timestr,
          describes: item.describes,
        });
      });

    _payload = {
      // type,
      detail: data,
      userId: data.userId,
      planId: data.planId,
      markers,
      discipline: data.imglist
        .sort((a, b) => a.times - b.times)
        .map((item) => ({
          fileinfoId: item.fileinfoId,
          times: item.times,
          describes: item.describes,
        })),
      store,
      activity,
    };
    await this.setState(_payload);
  };

  handleDetailChange = async ({ id }) => {
    const resp = await detail({ id });
    if (resp && resp.success) {
      const result = resp.data;
      await this.detailFormatter(result);
      await this.setState({
        resource: {
          selectKey: undefined,
          list: [],
        },
      });
      this.getPlay();
    }
  };

  handleSubmit = async () => {
    await MessageConfirm('确定提交么?');
    const {
      match: { params },
    } = this.props;
    const { userId, deptId } = getUser() || {};
    const type = params.type === 'live' ? '1' : '2';
    const { conference, uploader, planId, discipline, markers, store, activity } = this.state;
    const programId = uploader && uploader.getProgramId();
    const otherPayload = {};
    if (type === '1') {
      otherPayload.imglist = discipline.map((item) => ({ id: item.id }));
    } else {
      let arr = [];
      Object.keys(markers).forEach((fileinfoId) => {
        arr = [...arr, ...markers[fileinfoId].map((item) => ({ ...item, fileinfoId }))];
      });
      otherPayload.afterlist = arr;
    }
    const supervisionscorelist = Object.keys(store).map((key) => ({
      indexId: key,
      score: store[key],
    }));
    const payload = {
      planId,
      type,
      deptId,
      userId,
      curriculumId: conference.id,
      programId,
      supervisionscorelist,
      ...activity,
      ...otherPayload,
    };
    const resp = await save(payload);
    if (resp && resp.success) {
      Toast.info('提交成功');
      window.location.reload();
    }
  };

  getPlan = async () => {
    // const { deptId } = getUser() || {};
    const { detail, conferenceInfo } = this.state;
    const _payload = {};
    let param = {};
    if (!conferenceInfo) {
      return;
    }
    if (!detail) {
      const subject = conferenceInfo.subject || conferenceInfo.sub_subject;
      if (!subject) {
        return;
      }
      param = { subject: subject.attributeValue };
    }
    const resp = await getSupervisionPlan(param);
    if (resp && resp.success) {
      const planOptions = resp.data;
      if (!detail && planOptions.length > 0) {
        const [{ id }] = planOptions;
        _payload.planId = id;
      }
      _payload.planOptions = planOptions;
      this.setState(_payload);
    }
  };

  render() {
    const {
      type,
      detail,
      detailList,
      isSuperviser,
      conferenceInfo = {},
      media,
      player,
      resource,
      shotModal,
      markerModal,
      markers = {},
      activity = {},
      discipline,
      planOptions,
      planId,
      store,
      error,
      conference,
    } = this.state;
    if (type === '2') {
      TabsInfo[2] = { title: '课堂记录' };
    }
    const disabled = !!detail || !isSuperviser;
    let mbsType = '';
    if (conference) {
      const { liveRecordInfo } = conference;
      if (liveRecordInfo) {
        mbsType = liveRecordInfo.mbsType;
      }
    }
    return (
      <div className="rts-detail-content">
        <div className="rts-detail-overflowAuto">
          <div className="supervise-player">
            <PlayerView
              mbsType={mbsType}
              mode={media.mode}
              type={media.type}
              fileInfoId={media.fileInfoId}
              error={error}
              handlePlayer={(player) => {
                this.setState({ player });
                window.player = player;
                this.setPlayMarkers();
              }}
            />
          </div>
          {detailList.length > 0 && (
            <div style={{ height: '14vw', marginBottom: '2.8vw' }}>
              <Tabs
                tabs={detailList.map((item) => ({ id: item.id, title: item.realName }))}
                onChange={this.handleDetailChange}
              />
            </div>
          )}
          <ConferenceInfo
            conferenceInfo={{
              ...conferenceInfo,
              supervisorName: detail ? detail.realName : undefined,
              supervisorScore: detail ? detail.sumScore : undefined,
            }}
          />
          {resource.list.length > 1 && (
            <FileList
              value={resource.selectKey}
              list={resource.list}
              handleClick={this.handleFileClick}
            />
          )}
          {isSuperviser && (
            <Tabs
              tabs={TabsInfo}
              initialPage={0}
              tabBarPosition="top"
              swipeable={false}
              renderTab={(tab) => <span>{tab.title}</span>}
            >
              <div className="rts-datail-tabs-plane">
                <SupervisionScore
                  disabled={disabled}
                  value={planId}
                  storeValue={store}
                  planOptions={planOptions}
                  handlePlanChange={(planId) => this.setState({ planId })}
                  handleNormChange={(store) => this.setState({ store })}
                />
              </div>
              <div className="rts-datail-tabs-plane">
                <ClassroomBehavior
                  refresh={!detail}
                  onRefresh={this.getExpanInfo}
                  disabled={disabled}
                  value={activity}
                  handleChange={(activity) => this.setState({ activity })}
                />
              </div>
              <div className="rts-datail-tabs-plane">
                {type === '1' && (
                  <ClassroomDiscipline
                    showRemove={!detail}
                    list={discipline}
                    handleClick={(item) => this.handleReShowShot(item)}
                    handleRemove={(item, index) => this.handleRemoveShot(item, index)}
                  />
                )}
                {type === '2' && (
                  <ClassroomRecord
                    list={markers[resource.selectKey]}
                    handleClick={(item, index) => this.handleReShowMarkers(item, index)}
                  />
                )}
              </div>
              <div className="rts-datail-tabs-plane">
                <ClassroomEvaluation
                  disabled={disabled}
                  value={activity.evaluate}
                  onChange={(evaluate) => this.setState({ activity: { ...activity, evaluate } })}
                />
              </div>
            </Tabs>
          )}
        </div>
        {!disabled && (
          <>
            {type === '1' && <Screenshot player={player} handleSnapshot={this.handleSnapshot} />}
            {type === '2' && (
              <Button onClick={() => this.handleMarker()} className="supervise-recordplus"></Button>
            )}

            <Button onClick={this.handleSubmit} className="supervise-submit" type="primary">
              提交
            </Button>
          </>
        )}
        <ShotModal
          disabled={disabled}
          visible={shotModal.visible}
          value={shotModal.record}
          onOk={(data) => this.handleSyncAppendix(data)}
          onCancel={() => this.setState({ shotModal: { ...shotModal, visible: false } })}
          afterClose={() => this.setState({ shotModal: { visible: false, record: undefined } })}
        />
        <MarkerModal
          disabled={disabled}
          visible={markerModal.visible}
          value={markerModal.record}
          onOk={(data) => this.handleSyncMark(data)}
          onCancel={() => this.setState({ markerModal: { visible: false, record: undefined } })}
        />
      </div>
    );
  }
}

export default Supervise;
